import { render, staticRenderFns } from "./FormReceive.vue?vue&type=template&id=03e11eea"
import script from "./FormReceive.vue?vue&type=script&lang=js"
export * from "./FormReceive.vue?vue&type=script&lang=js"
import style0 from "./FormReceive.vue?vue&type=style&index=0&id=03e11eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports